<template>
  <section class="mx-auto max-w-[1180px] px-4 py-4 lg:py-16 text-dark">
    <div v-if="loading" class="rounded-[32px] bg-light px-8 py-14 text-center">
      <slot>
        <loader />
      </slot>
    </div>

    <div v-else-if="loadFailed" class="rounded-[32px] bg-light px-8 py-14">
      <LoadError message="We couldn't load your booking. Check your connection and try again." @retry="loadBooking" />
    </div>

    <thanks v-else />
  </section>
</template>

<script setup>
import "./helpers/form-setup"
import { onMounted, ref } from "vue"
import Loader from "./components/Loader.vue"
import LoadError from "./components/LoadError.vue"
import { reportLoadError } from "../helpers/network"
import { Thanks } from "./routes"
import useStore from "./store"

const props = defineProps({
  booking: {
    type: [String, Boolean],
    default: false,
  },
  token: {
    type: [String, Number, Boolean],
    default: false,
  },
})

const loading = ref(true)
const loadFailed = ref(false)

const loadBooking = async () => {
  const store = useStore()
  const params = new URLSearchParams(window.location.search)
  const bookingNumber = props.booking || params.get('booking')
  const token = props.token || params.get('token')

  if (!bookingNumber || !token) {
    loading.value = false
    return
  }

  loading.value = true
  loadFailed.value = false

  try {
    await store.loadOptions()
    await store.loadAttractions()
    await store.loadBooking(bookingNumber, token)
  } catch (error) {
    loadFailed.value = true
    reportLoadError(error)
  } finally {
    loading.value = false
  }
}

onMounted(loadBooking)
</script>
